import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-base-component',
    template: '',
    standalone: false
})
export class BaseInputComponent implements OnDestroy {
  private _subscriptions: Subscription[] = [];

  _(sub: Subscription) {
    this._subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    for (const sub of this._subscriptions) {
      sub.unsubscribe();
    }
  }
}
